const ListItem=(props)=>{
	let className=props.item.status=='Open' ? 'open' : 'close';
	className=className+"-btn";
	return (
		<>


		<div className="list-box">
	        <img src="/img/heart.png" className="heart" />
	        <h3>{props.item.wl_title}</h3>
	        <p>500 W 900 N Provo Utah 84604</p>
	        <div className="list-box-flex">
	          <div><button className={className}>{props.item.status}</button></div>
	          {/*}
	          <div className="list-box-icon">
	            <a href={props.item.wl_link} target="_blank"><img src="/img/Group238489.png" /></a>
	            <a href="#"><img src="/img/Group238491.png" /></a>
	            <a href="#"><img src="/img/Group238493.png" /></a>
	            <a href="#"><img src="/img/Group238494.png" /></a>
	          </div>
	          {*/}
	          <button className="blue-btn">View Details</button>
	        </div>
	      </div>


		</>
		)
};
export default ListItem; 